import { FC } from 'react';

import { FormInputsProps, RenderFormComponentsProps } from '../types';
import { FormDateInput } from './FormDateInput';
import { FormInput } from './FormInput';
import { FormPasswordInput } from './FormPasswordInput';
import { FormPhoneInput } from './FormPhoneInput';
import { FormSelect } from './FormSelect';
import { useFormContext } from 'react-hook-form';

const fieldComponentMap = {
  source_wallet_pwd: FormPasswordInput,
  phone: FormPhoneInput,
  birthday: FormDateInput
};

export const Fields: FC<FormInputsProps> = ({ field }) => {
  const { name, type } = field;
  const {
    formState: { defaultValues }
  } = useFormContext();

  const renderFormComponent = ({ type, name, field }: RenderFormComponentsProps): JSX.Element => {
    const defaultValue = defaultValues?.[name];
    if (type === 'select') return <FormSelect field={field} />;
    const Component = fieldComponentMap[name as keyof typeof fieldComponentMap] || FormInput;
    return <Component field={field} defaultValue={defaultValue} />;
  };

  return renderFormComponent({ type, name, field });
};
